module.exports = __webpack_public_path__ + "img/TW.71162f46.png";